import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 100861 90899"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:1117.74}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974319854944">
        <path
          d="M32695 13276c0 6610 1461 20165 3747 24489 916-246 636-324 1326-922 5469-4742 14424-5496 20987-2651l4211 2536c735 587 562 561 1464 1037 1797-3398 5685-23589 2579-30817-705-1637-2142-3268-3656-4091-4362-2377-7146-1843-11170-2075-1053-59-892-223-1747-223l-6998 471c-3992 428-7807 2087-9498 5745-751 1623-1245 4105-1245 6501zM44189 72499c-2218-1065-2708-777-5496-2750-6711-4749-10188-12912-8249-21239-3225 0-9965 2743-12672 3818-1013 404-1885 763-2815 1183C9011 56186-534 60198 660 68294c616 4174 3155 8672 4998 11750 4714 7875 9484 14050 20211 7618 924-555 1587-923 2481-1517 3871-2580 6055-4415 9559-7183 1389-1097 5897-5033 6280-6463zM70927 52258c0 7305-3019 13721-8595 17394-1519 1000-3752 2403-5649 2847 583 2184 6063 6142 8059 7930 1846 1653 7386 5410 9481 6763 10279 6641 15915 2003 21267-7621 7537-13544 7307-18439-8567-25569-3198-1436-12432-5492-16497-5492 278 1190 501 2264 501 3748zM36422 52210c0 6008 2865 11327 8173 13541 5523 2303 11428 1419 15668-2729 6803-6655 5145-18229-3574-22591-3872-1935-8509-2008-12373-66-2901 1459-5068 3551-6517 6511-629 1285-1377 3440-1377 5334z"
          className="fill stroke1"
          style={{
            strokeWidth: 1117.74,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
